export default __webpack_public_path__ + "static/media/property_562.6423883d.png";